import { HEALTH } from "./UploadEvents";

/**
 * Pure decision function: given a health transition and the set of trigger
 * names we've already captured a snapshot for on this upload, return the
 * trigger name a new snapshot should be captured under — or null.
 *
 * Extracted from StuckDetector so the dedupe rule can be tested without
 * spinning up the sweeper interval + registry singleton.
 *
 * Fixes the 2026-08 observability suppression bug: a single Set across all
 * trigger types meant that a POSSIBLY_STUCK capture blocked the eventual
 * FAILURE capture on the same upload, hiding the actual killer error.
 * Deduping per-trigger lets stuck → failure both fire (latest-wins on the
 * backend TEXT column, so the failure snapshot overwrites the stuck one).
 *
 * @param {string} nextHealth      HEALTH enum value from the current sweep
 * @param {string} previousHealth  HEALTH value from the prior sweep
 * @param {Set<string>} alreadyCaptured  trigger names captured for this uploadId
 * @returns {"stuck" | "failure" | "completed" | null}
 */
export const decideCapture = (nextHealth, previousHealth, alreadyCaptured) => {
  if (
    nextHealth === HEALTH.POSSIBLY_STUCK &&
    !alreadyCaptured.has("stuck")
  ) {
    return "stuck";
  }
  if (
    nextHealth === HEALTH.FAILED &&
    previousHealth !== HEALTH.FAILED &&
    !alreadyCaptured.has("failure")
  ) {
    return "failure";
  }
  if (
    nextHealth === HEALTH.COMPLETED &&
    previousHealth !== HEALTH.COMPLETED &&
    !alreadyCaptured.has("completed")
  ) {
    return "completed";
  }
  return null;
};
